import React from 'react'
import clsx from 'clsx'
import ListaDescripciones from './lista-descripciones'
import UnderlinedTitle from '../../shared/underlinedText/underlined-title'

interface Valor {
  titulo: string
  texto: string
  icono?: string // Aseguramos que los iconos estén definidos
}

type listas = Valor[]

interface DescripcionesProps {
  items: listas
  titulo: string
  subrayado: string
  blanco: boolean
  className?: string
  iconosComponentes?: boolean
  margen?: boolean
}

const Descripciones = (props: DescripcionesProps): any => {
  return (
    <div
      className={clsx(
        'max-w-[1200px] flex flex-col justify-center items-center mx-auto pl-[6px]',
        props.className
      )}
    >
      <div className="w-full flex flex-col md:flex-row md:justify-between gap-6 mt-[10px]">
        <div className="md:w-1/2">
          <UnderlinedTitle
            blanco={props.blanco}
            texto={props.titulo}
            width="100%"
            palabrasSubrayadas={props.subrayado}
            marginTop="0px"
            marginLeft={false}
            divWidth="100%"
          />
        </div>
        <div className="md:w-1/2 mt-0 md:mt-[44px]">
          <ListaDescripciones items={props.items} iconosComponentes={props.iconosComponentes} />
        </div>
      </div>
    </div>
  )
}

export default Descripciones
